import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MmButtonModule, MmFlexLayoutModule, MmIconModule } from '@metromarkets/components';
import { QaLocatorsModule } from '@metromarkets/sdk';
import { MmPopoverModule } from '~shared/modules/popover/popover.module';
import {
  PriceTypeExplanationPopupComponent
} from './components/price-type-explanation-popup/price-type-explanation-popup.component';
import {
  MobileExplanationMessageComponent
} from '~shared/modules/price-type-toggler/components/mobile-explanation-message/mobile-explanation-message.component';

@NgModule({
  declarations: [
    MobileExplanationMessageComponent,
    PriceTypeExplanationPopupComponent,
  ],
  exports: [
    MobileExplanationMessageComponent,
    PriceTypeExplanationPopupComponent
  ],
  imports: [
    CommonModule,
    MmPopoverModule,
    MmButtonModule,
    TranslateModule,
    MmFlexLayoutModule,
    MmIconModule,
    QaLocatorsModule,
  ]
})
export class PriceTypeTogglerModule {}

export { PriceTypes } from './models/price-types.enum';
export { PriceTypeService } from './services/price-type.service';
